import script from "./RegisterCanicross2026.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterCanicross2026.vue?vue&type=script&setup=true&lang=js"

import "./RegisterCanicross2026.vue?vue&type=style&index=0&id=4acb0381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acb0381"]])

export default __exports__